<form (ngSubmit)="onSave()">
    <div>
        <div>
            <mat-slide-toggle class="is-favorite-mat-slide-toggle"
                              name="isfavorite"
                              [color]="'primary'"
                              [(ngModel)]="this.IsFavorite"
                              (ngModelChange)="this.handleIsFavoriteChanged()">
                Favorite
            </mat-slide-toggle>

            <mat-icon svgIcon="{{this.FavoriteIconName}}"
                      class="star-preview-mat-icon"
                      (click)="this.toggleFavorite()"></mat-icon>
        </div>

        <mat-form-field appearance="outline"
                        [floatLabel]="'always'"
                        class="favorite-title-mat-form-field">
            <mat-label>{{this.FavoriteTitleLabelText}}</mat-label>

            <input matInput
                   type="text"
                   name="favoritetitle"
                   [readonly]="this.IsReadOnly"
                   class="favorite-title-mat-input"
                   placeholder="{{this.PlaceholderText}}"
                   [(ngModel)]="this.FavoriteTitle" />
        </mat-form-field>
    </div>

    <div class="button-wrapper">
        <button mat-raised-button
                type="submit"
                color="primary"
                [disabled]="this.SaveDisabled">
            Save
        </button>

        &nbsp;
        &nbsp;

        <button mat-raised-button
                type="button"
                (click)="this.onCancel()">
            Cancel
        </button>
    </div>
</form>
